import { ISearchProvider } from '../../domain/search-provider';
import { IAddressV2 } from '@jump-tech-frontend/domain';

export const getGoogleSearchProvider = (): ISearchProvider => {
  return {
    name: 'google',
    search: async (searchTerm: string) => {
      const autocompleteService = new google.maps.places.AutocompleteService();
      const currentSessionToken = new google.maps.places.AutocompleteSessionToken();
      const request = {
        input: searchTerm,
        language: 'en-US',
        type: ['address'],
        region: 'us',
        token: currentSessionToken
      };
      const result: google.maps.places.AutocompleteResponse = await autocompleteService.getPlacePredictions(request);
      return result?.predictions.map(prediction => ({
        id: prediction.place_id,
        description: prediction.description
      }));
    },
    getResult: async (id: string) => {
      const mapDiv = document.createElement('div');
      return new Promise((resolve, reject) => {
        const service = new google.maps.places.PlacesService(mapDiv);
        const request: google.maps.places.PlaceDetailsRequest = {
          placeId: id,
          fields: ['address_components', 'geometry']
        };
        service.getDetails(
          request,
          (place: google.maps.places.PlaceResult | null, status: google.maps.places.PlacesServiceStatus) => {
            if (status === google.maps.places.PlacesServiceStatus.OK && place) {
              resolve(addressResponseToAddressV2Transform(place));
            } else {
              reject(new Error(`Address lookup failed: ${status}`));
            }
          }
        );
      });
    }
  };
};

function addressResponseToAddressV2Transform(placeResult: google.maps.places.PlaceResult): IAddressV2 {
  return {
    line1: [
      getGoogleAddressComponentByType(placeResult, 'street_number'),
      getGoogleAddressComponentByType(placeResult, 'route')
    ].join(' '),
    line2: getGoogleAddressComponentByType(placeResult, 'sublocality'),
    town: getGoogleAddressComponentByType(placeResult, 'locality'),
    country: getGoogleAddressComponentByType(placeResult, 'country'),
    postCode: getGoogleAddressComponentByType(placeResult, 'postal_code'),
    county: getGoogleAddressComponentByType(placeResult, 'administrative_area_level_1'),
    latitude: placeResult.geometry?.location?.lat().toString() ?? undefined,
    longitude: placeResult.geometry?.location?.lng().toString() ?? undefined,
    countryCode: 'us'
  };
}

function getGoogleAddressComponentByType(
  placeResult: google.maps.places.PlaceResult,
  type: string
): string | undefined {
  const match = placeResult.address_components?.find(ac => ac.types.includes(type));
  return match?.long_name ?? undefined;
}
